<template>
  <div
    :class="{'start-overflow': startOverflow, 'end-overflow': endOverflow}"
    class="sub-navigation wrap-container"
  >
    <svgicon
      v-if="startOverflow"
      name="Navigation/AngleLeft"
      class="sub-navigation__chevron chevron-left"
      @click="scrollListLeft"
    />
    <template v-if="inEditMode">
      <ul
        ref="subnavList"
        class="sub-navigation__list"
      >
        <li
          v-for="item in menuItems"
          :key="item.label"
          class="sub-navigation__item"
        >
          <a
            :class="{'active': item.isActive}"
            :href="item.url"
            v-text="item.label"
          />
        </li>
      </ul>
    </template>
    <template v-else>
      <ul
        ref="subnavList"
        v-dragscroll.x="true"
        class="sub-navigation__list"
        @dragscrollmove="dragScrollMove"
        @dragscrollend="dragScrollEnd"
      >
        <li
          v-for="item in menuItems"
          :key="item.label"
          class="sub-navigation__item"
        >
          <a
            :class="{'active': item.isActive}"
            :href="item.url"
            :target="item.target"
            @click="checkDragStatus"
            v-text="item.label"
          />
        </li>
      </ul>
    </template>
    <svgicon
      v-if="endOverflow"
      name="Navigation/AngleRight"
      class="sub-navigation__chevron chevron-right"
      @click="scrollListRight"
    />
  </div>
</template>

<script>
import ScrollObserver from '@/utils/scrollObserver'
import hideElementOnScroll from './hideElementOnScroll'
import '#/Navigation/AngleRight'
import '#/Navigation/AngleLeft'

export default {
  props: {
    menuItems: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      mainNavHidden: false,
      currentDragScroll: 0,
      startOverflow: false,
      endOverflow: false
    }
  },
  beforeDestroy () {
    ScrollObserver.removeAllCallbacks(this.$el)
  },
  mounted () {
    ScrollObserver.addCallback(this.$el, hideElementOnScroll)

    this.checkOverflow()
  },
  methods: {
    checkDragStatus (e) {
      if ( Math.abs(this.currentDragScroll) <= 30 ) {
        return true
      } else {
        e.preventDefault()
        return false
      }
    },
    dragScrollMove (e) {
      this.currentDragScroll += e.detail.deltaX
      this.checkOverflow()
    },
    dragScrollEnd () {
      this.$nextTick( () => {
        this.currentDragScroll = 0
      })
    },
    checkOverflow () {
      const possibleOverflow = this.$refs.subnavList.scrollWidth - this.$refs.subnavList.clientWidth

      this.startOverflow = this.$refs.subnavList.scrollLeft > 0
      if (possibleOverflow > 0 && this.$refs.subnavList.scrollLeft + 10 <= possibleOverflow) {
        this.endOverflow = true
      } else {
        this.endOverflow = false
      }
    },
    scrollListLeft () {
      this.$refs.subnavList.scrollLeft -= 80
      this.checkOverflow()
    },
    scrollListRight () {
      this.$refs.subnavList.scrollLeft += 80
      this.checkOverflow()
    }
  }
}
</script>

<style lang="scss">
.sub-navigation {
  background-color: $color-white;
  display: block;
  position: relative;
  z-index: 1;

  @include media-breakpoint-up (lg) {
    display: block;
  }

  &.hiding {
    border-top-color: $color-transparent;
  }

  &::before,
  &::after {
    bottom: 0;
    content: '';
    display: block;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transition: opacity 250ms ease;
    width: 2rem;
    z-index: 10;
  }

  &::before {
    left: 1rem;
    background: linear-gradient(to right, $color-white 40%, rgba(255, 255, 255, 0) 100%);
  }

  &::after {
    right: 1rem;
    background: linear-gradient(to left, $color-white 40%, rgba(255, 255, 255, 0) 100%);
  }

  &.start-overflow::before {
    opacity: 1;
  }

  &.end-overflow::after {
    opacity: 1;
  }

  /*
  MOVE TO PARENT
    .header-navigation-wrapper.mainNavHidden & {
      display: none;

      @include media-breakpoint-up (lg) {
        display: block;
      }
    }
  */
  &__list {
    @include font(text, 3, light);

    margin: 0;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    user-select: none;
  }

  &__item {
    display: inline-block;
    padding: 0 0.5rem;

    &:first-child {
      padding-left: 0;
    }

    a {
      color: $color-grey-dark;
      display: inline-block;
      padding: 0.75rem 0;
      position: relative;
      text-decoration: none;

      @include font(text, 2, normal);

      &.active {
        color: $color-red-dark;
        font-weight: normal;
      }
    }
  }

  &__chevron {
    width: 1rem;
    height: 1rem;
    fill: $color-orange-dark;
    position: absolute;
    top: 0.75rem;
    cursor: pointer;
    z-index: 12;

    &.chevron-left {
      left: 0.5rem;
    }

    &.chevron-right {
      right: 0.5rem;
    }
  }
}
</style>
